



























import {Component, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/dialog/DialogMixin';
import Schedule from '@/views/journals/schedule/Schedule.vue';

@Component({
    inheritAttrs: false,
    components: {
        Schedule,
    },
})
export default class ScheduleSearchDialog extends Mixins(DialogMixin) {
    onSearchInput(data: any) {
        this.$emit('search:input', data);
        this.close();
    }
}
